import React, { useState, useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import AuthContext from "context/AuthContext";
import Hiring from "./hiring/Hiring";
import Onboarding from "./onboarding/Onboarding";

const tabBtnClass = "inline-block py-3 px-8 text-md xl:text-lg font-semibold border-b-2";
const tabActiveClass = "border-blue-600 text-blue-600";
const tabBorderNoneClass = "border-transparent";
const TAB_HIRING = "hiring";
const TAB_ONBOARDING = "onboarding";
const FormsManager = () => {
  const { t } = useTranslation();
  const { updatePageName, user } = useContext(AuthContext);
  const manager = user?.permission?.find((e) => e.manager === "forms-manager") ?? {};
  const [defaultTab, setDefaultTab] = useState("hiring");
  const handleTabClick = (action, e) => {
    setDefaultTab(action);
  };

  useEffect(() => {
    updatePageName(t("FORMS_MANAGER"));
  }, []);
  return (
    <div className="">
      <div className="py-3 my-2">
        <ul className="border-b flex">
          <li className="mr-0 xl:mr-5">
            <button
              onClick={handleTabClick.bind(this, TAB_HIRING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_HIRING,
                [tabBorderNoneClass]: defaultTab !== TAB_HIRING,
              })}
            >
              {t("HIRING")}
            </button>
          </li>
          <li className="mx-0 xl:mx-5">
            <button
              onClick={handleTabClick.bind(this, TAB_ONBOARDING)}
              className={classNames({
                [tabBtnClass]: true,
                [tabActiveClass]: defaultTab === TAB_ONBOARDING,
                [tabBorderNoneClass]: defaultTab !== TAB_ONBOARDING,
              })}
            >
              {t("ONBOARDING")}
            </button>
          </li>
        </ul>
      </div>

      {defaultTab === TAB_HIRING ? <Hiring manager={manager} /> : defaultTab === TAB_ONBOARDING && <Onboarding manager={manager} />}
    </div>
  );
};

export default FormsManager;
